import angular from 'angular';

export default class UsersByRelation {
  constructor($scope, UserService, PaginationService) {
    $scope.get_tabs = function() {
      var tabs = [
        {
          title: 'Unqualified Leads',
          relation_id: 0,
          users: [],
          page: 1
        },
        {
          title: 'Qualified Leads',
          relation_id: 1,
          users: [],
          page: 1
        },
        {
          title: 'Contacts',
          relation_id: 2,
          users: [],
          page: 1
        },
      ];
      if (window.user_type == 'buyer')
        tabs.push({
          title: 'Customers',
          relation_id: 3,
          users: [],
          page: 1
        });
      else
        tabs.push({
          title: 'Corporate Suppliers',
          relation_id: 4,
          users: [],
          page: 1
        });
      return tabs;
    };

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.query = '';
    };

    $scope.quick_search = function() {
      window.filter_table('table#users', $scope.query);
    };

    $scope.common_filters = function() {
      return {
        per_page: 50,
        user_type: window.user_type,
        countries: $scope.country_id ? [$scope.country_id] : []
      };
    };

    $scope.load_users = function(tab) {
      $scope.query = '';
      var filters = $scope.common_filters();
      filters['page'] = tab.page;
      filters['relation_id'] = tab.relation_id;
      UserService.search(filters).then(function(data) {
        tab.users = data.users;
        tab.pagination = PaginationService.get_pagination(data.pagination);
      });
    };

    $scope.reload_users = function() {
      angular.forEach($scope.tabs, function(tab) {
        $scope.load_users(tab);
      });
    };

    $scope.init = function() {
      $scope.country_id = null;
      $scope.countries = window.countries;
      $scope.tabs = $scope.get_tabs();
      $scope.selected_tab = 0;
      $scope.reload_users();
    };

    $scope.init();
  }
}

UsersByRelation.$inject = ['$scope', 'UserService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/users-by-relation.ctrl.js